// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { LocationType } from '@/location/api/types';

/** Which record kinds carry a field at all */
type LocationFieldScope = 'both' | 'site' | 'zone';

/**
 * The single definition of which fields a site and a zone each hold. A zone computes its
 * company from the parent site, reads that site's address, and cannot be transient; a site has
 * no description or consignee of its own. Both the merge dialog and the merge audit render off
 * this, so the two cannot drift.
 */
export const LOCATION_FIELD_SCOPES = {
  name: 'both',
  company: 'site',
  address: 'site',
  isInventory: 'both',
  isTransient: 'site',
  description: 'zone',
  consignee: 'zone',
} as const satisfies Record<string, LocationFieldScope>;

export type LocationField = keyof typeof LOCATION_FIELD_SCOPES;

export function appliesToLocationType(
  field: LocationField,
  locationType: LocationType
): boolean {
  const scope: LocationFieldScope = LOCATION_FIELD_SCOPES[field];
  if (scope === 'both') return true;
  return scope === (locationType === 'ZONE' ? 'zone' : 'site');
}

export const LOCATION_FIELD_SCOPE_LABELS: Record<
  LocationFieldScope,
  string | null
> = {
  both: null,
  site: 'Location only',
  zone: 'Zone only',
};
